import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="bb-error">
      <h1 className="bb-display">Page introuvable</h1>
      <p>Cette page n'existe pas (ou plus).</p>
      <Link className="bb-btn bb-btn--primary" to="/">Retour à l'accueil</Link>
    </div>
  );
}

export default NotFound;
